import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05ecd66f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-time-picker" }
const _hoisted_2 = { class: "item-inner-time-picker" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1))
const _hoisted_6 = { class: "item-inner-time-picker" }
const _hoisted_7 = ["value", "disabled"]
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        class: "form-control form-control-sm form-control-solid justify-content-around",
        name: "hours",
        value: _ctx.hours,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:hours', $event.target.value)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHourRange, (hour) => {
          return (_openBlock(), _createElementBlock("option", {
            value: hour,
            key: hour
          }, _toDisplayString(hour), 9, _hoisted_4))
        }), 128))
      ], 40, _hoisted_3)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("select", {
        class: "form-control form-control-sm form-control-solid justify-content-around",
        name: "minutes",
        value: _ctx.minutes,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:minutes', $event.target.value))),
        disabled: _ctx.block_minutes
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMinuteRange, (minute) => {
          return (_openBlock(), _createElementBlock("option", {
            value: minute,
            key: minute
          }, _toDisplayString(minute), 9, _hoisted_8))
        }), 128))
      ], 40, _hoisted_7)
    ])
  ]))
}